import { Create, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { partnerStatusChoices } from '../../lib/partners';

const PartnerCreate = () => (
  <Create redirect="show">
    <SimpleForm defaultValues={{ status: 'active' }}>
      <TextInput source="name" label="Name" validate={required()} />
      <SelectInput source="status" label="Status" choices={partnerStatusChoices} validate={required()} />
    </SimpleForm>
  </Create>
);

export default PartnerCreate;
